import type { TCreditFormCommonFields } from 'entities/creditForm';
import { Phone, Snils, Education } from 'entities/creditForm/lib/formatters/base';

export class Additional {
  constructor(
    private readonly data: Pick<
      Partial<TCreditFormCommonFields>,
      | 'education'
      | 'maritalStatus'
      | 'numberOfDependents'
      | 'additionalPhone'
      | 'additionalPhoneOwner'
      | 'additionalPhoneOwnerFullName'
      | 'propertyTypeAvailability'
      | 'snils'
    >,
    // eslint-disable-next-line no-empty-function
  ) {}

  profile() {
    const education = new Education(this.data.education).map();
    const snils = new Snils(this.data.snils).map();

    return {
      education,
      maritalStatus: this.data.maritalStatus?.value || null,
      numberOfDependents: this.data.numberOfDependents?.value,
      additionalPhone: new Phone(this.data.additionalPhone).format(),
      additionalPhoneOwner: this.data.additionalPhoneOwner?.value || null,
      additionalPhoneOwnerFullName: this.data.additionalPhoneOwnerFullName?.value || null,
      propertyTypeAvailability: this.data.propertyTypeAvailability?.value || null,
      snils,
    };
  }

  loans() {
    const {
      education,
      additionalPhone,
      additionalPhoneOwner,
      additionalPhoneOwnerFullName,
      maritalStatus,
      numberOfDependents,
      propertyTypeAvailability,
      snils,
    } = this.profile();

    return {
      education: education || null,
      maritalStatus: maritalStatus || null,
      additionalPhone: additionalPhone || '',
      additionalPhoneOwner: additionalPhoneOwner || null,
      propertyTypeAvailability: propertyTypeAvailability || null,
      additionalPhoneOwnerFullName: additionalPhoneOwnerFullName || null,
      snils: snils || undefined,
      numberOfDependents: numberOfDependents || 'None',
      incomeConfirmation: 'Ndfl2' as const,
      employerStatus: 'ACTIVE',
    };
  }
}
